import { select as d3_select } from 'd3-selection'
import { ACCESSIBILITY_OPTIONS_KEYS } from '../utils/accessibilityUtils'
function TooltipBehavior(chart, config = {}) {
  // console.log("config",config)
  let tooltipData = []
  let tooltipRoot = d3_select(chart.$root.closest('.wrapper'))
  let updateTooltip = function (itemsKey) {
    //Bastante guarrero, pero efectivo...
    if (!chart.config.TooltipBehavior.enableTooltips) tooltipData = []

    let tooltip = tooltipRoot.selectAll('.tooltip').data(tooltipData)

    tooltip.exit().remove()

    let tooltipEnter = tooltip
      .enter()
      .append('div')
      .attr('class', 'tooltip')
      .style('opacity', 0)
      .style('color', '#444')

    tooltipEnter.transition().duration(200).style('opacity', 1)

    tooltipEnter.style('position', 'absolute').style('pointer-events', 'none')

    tooltipEnter
      .append('div')
      .attr('class', 'content')
      .style('position', 'absolute')
      .style('bottom', 0)
      .style('transform', 'translate(-50%,-5px)') //HAY QUE PONERlO "donde iria" para detectar bien si colisiona!
      .style('background', '#fff')
      .style('border', 'solid 1px #EBEBEB')
      .style('border-radius', '5px')
      .style('padding', '6px 12px')
      .style('text-align', 'center')
      .style('white-space', 'wrap')
      .style('font-family', 'santander-microtext-embedded')
      .style('font-size', '10px')
      .style('max-width', '180px')
      .style('line-height', '1.4em')
      .style('box-shadow', '0px 6px 6px rgba(111,119,121, 0.15)')
      .append('div')
      .attr('class', 'content-wrapper')
      .style('width', 'max-content')
      .style('max-width', '100%')
      .style('word-wrap', 'break-word')

    tooltipEnter
      .append('div')
      .attr('class', 'tip-border')
      .style('position', 'absolute')
      .style('bottom', 0)
      .style('width', 0)
      .style('height', 0)

    tooltipEnter
      .append('div')
      .attr('class', 'tip')
      .style('position', 'absolute')
      .style('bottom', 0)
      .style('width', 0)
      .style('height', 0)

    tooltip = tooltip.merge(tooltipEnter)
    tooltip.style('top', d => `${d.pos.top}px`).style('left', d => `${d.pos.left}px`)

    tooltip
      .select('.content')
      .select('.content-wrapper')
      .html(d => {
        return config.getHtml.call(chart, d.datum, itemsKey)
      })
      .style(
        'font-size',
        chart._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.increaseTextSize]
          ? '18px'
          : '14px'
      )
      .style('color', '#767676')
      .style('line-height', '22px')
      .selectAll('.important')
      .style(
        'font-size',
        chart._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.increaseTextSize]
          ? '20px'
          : '16px'
      )
      .style('font-weight', '700')
      .style('line-height', '22px')
      .style('color', '#444444')
    tooltip
      .selectAll('.secondary')
      .style('font-weight', '300')
      .style('line-height', '22px')
      .style('font-style', 'italic')

    // Tooltip repositioning:
    let node = tooltip.select('.content').node()
    if (node) {
      chart.emit('tooltip', tooltip.datum().datum)

      // Hay que ponerla primero "donde iria" para poder medir BIEN con el GetBoundingClientRect!
      let tx = '-50%'
      let ty = '-12px'
      tooltip.select('.content').style('transform', `translate(${tx},${ty})`)

      let size = (
        chart.$root.closest('.chart-container') || chart.$root.closest('.chart-wrapper')
      ).getBoundingClientRect()
      let rect = node.getBoundingClientRect()
      let tipBorder = 'top'
      if (rect.x + rect.width > size.x + size.width) {
        let diff = rect.x + rect.width - (size.x + size.width)
        tx = `calc(-50% - ${diff}px)`
      }
      if (rect.x < size.x) {
        let diff = size.x - rect.x
        tx = `calc(-50% + ${diff}px)`
      }
      if (rect.y < size.y) {
        ty = `calc(100% + 10px)`
        tipBorder = 'bottom'
      }
      tooltip.select('.content').style('transform', `translate(${tx},${ty})`)

      tooltip
        .select('.tip-border')
        .style('transform', `translate(-50%,${tipBorder === 'bottom' ? '11px' : '-1px'})`)
        .style('border-left', '6px solid transparent')
        .style('border-right', '6px solid transparent')
        .style('border-top', '6px solid transparent')
        .style('border-bottom', '6px solid transparent')
        .style(`border-${tipBorder}`, '6px solid #EBEBEB')

      tooltip
        .select('.tip')
        .style('transform', `translate(-50%,${tipBorder === 'bottom' ? '12px' : '-3px'})`)
        .style('border-left', '5px solid transparent')
        .style('border-right', '5px solid transparent')
        .style('border-top', '5px solid transparent')
        .style('border-bottom', '5px solid transparent')
        .style(`border-${tipBorder}`, '5px solid #fff')
    }
  }

  // Recorremos todos los "charts" (por si hay multiple)
  let roots = d3_select(chart.$root.closest('.chart-scroller'))
    .selectAll('.chart-wrapper')
    .select('svg')
  roots.on('mouseover', () => {
    if (chart.selection.length === 0) {
      tooltipData = []
      updateTooltip()
    }
  })

  // @Oslo: Review! This should remove tooltip on scroll events
  chart._parent._parent.addEventListener('translate', () => {
    tooltipData = []
    updateTooltip()
  })

  let itemsKeys = chart.config.TooltipBehavior.itemsKeys

  if (itemsKeys.length === 0) {
    console.warn('Chart doesnt have .items to add tooltips to')
    return
  }
  itemsKeys.forEach(key => {
    let items = chart[key + 'Enter']
    items.on('mousemove', (ev, d) => {
      if (
        chart.selection.length === 0 ||
        chart.selection.indexOf(d) >= 0 ||
        chart.selection.find(dd => dd.id === d.parentId)
      ) {
        let offset = tooltipRoot.node().getBoundingClientRect()
        let targetPos = chart.config.TooltipBehavior.getItemOffset.call(chart, ev.currentTarget, d)
        if (chart.config.TooltipBehavior.getHasTooltip.call(chart, d)) {
          tooltipData = [
            {
              datum: d,
              pos: { top: targetPos.y - offset.y, left: targetPos.x - offset.x },
            },
          ]
        } else {
          tooltipData = []
        }

        updateTooltip(key)
      }
    })
    //update "siempre" que cambie cualquier PROP o incluso el DATA, no?
    updateTooltip(key)
  })

  chart.showTooltipById = function (id) {
    let d = this.data.find(dd => dd.id === id)
    let offset = tooltipRoot.node().getBoundingClientRect()
    let $el = chart.items
      .merge(chart.itemsEnter)
      .filter(d => {
        return d.id === id
      })
      .node()
    let targetPos = chart.config.TooltipBehavior.getItemOffset.call(chart, $el, d)
    tooltipData = [
      {
        datum: d,
        pos: { top: targetPos.y - offset.y, left: targetPos.x - offset.x },
      },
    ]
    updateTooltip()
  }
}

TooltipBehavior.defaultConfig = {
  index: 202,
  itemsKeys: {
    type: [String, Array],
    default: ['items'],
  },
  /**
   * {-EN-} Enable/disable tooltips. When enabled tooltips will popup when items are hovered (tapped on mobile).
   * {-ES-} Activar/desactivar tooltips. Cuando esté habilitada, aparecerá el tooltip cuando se coloque el cursor sobre los elementos (se los toque en el dispositivo móvil).
   */
  enableTooltips: {
    type: Boolean,
    default: true,
    exposed: true,
  },
  tooltipValueFormat: {
    type: [String, Array, Function, null],
    default: null,
    exposed: true,
    nonEditable: true,
  },
  axis: {
    x: {
      tooltipValueFormat: {
        type: [String, Array, Function, null],
        default: null,
        exposed: true,
        nonEditable: true,
      },
    },
    y: {
      tooltipValueFormat: {
        type: [String, Array, Function, null],
        default: null,
        exposed: true,
        nonEditable: true,
      },
    },
    z: {
      tooltipValueFormat: {
        type: [String, Array, Function, null],
        default: null,
        exposed: true,
        nonEditable: true,
      },
    },
  },
  getHtml: {
    type: Function,
    default: function (d) {
      return `
        <div class="tip-value important">${this.formatTooltipValue(d.value, 'y')}</div>
        <div class="tip-id">
          <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
            { id: d.id }
          )}; margin-right: 3px"></span>
          ${d.id}
        </div>
      `
    },
  },
  getHasTooltip: {
    type: Function,
    default: function () {
      return true
    },
  },
  getItemOffset: {
    type: Function,
    default: function ($el) {
      let targetRect = $el.getBoundingClientRect()
      return {
        x: targetRect.x + targetRect.width / 2,
        y: targetRect.y + targetRect.height / 2, //- 5,
      }
    },
  },
}

TooltipBehavior.configName = 'TooltipBehavior'
export default TooltipBehavior
